import InputDropdownTrigger from "@/components/input-dropdown-trigger";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
import { FC } from "react";

export type RadioFilterItem = {
  id: string;
  value: string;
  enabled?: boolean;
};

type RadioFilterProps = {
  label: string;
  items: RadioFilterItem[];
  title?: string;
  selectedId?: string;
  onOpenChange?: (
    isOpen: boolean,
    selectedItem: RadioFilterItem | undefined,
  ) => void;
  onValueChange?: (selectedItem: RadioFilterItem | undefined) => void;
};

const RadioFilter: FC<RadioFilterProps> = (props) => {
  // Defines if the filter has a selected item
  const isActive = props.selectedId !== undefined;

  const handleValueChange = (selectedId: string) => {
    // If clicking the already selected item, deselect it
    if (selectedId === props.selectedId) {
      props.onValueChange?.(undefined);
      return;
    }
    const selectedItem = props.items.find((item) => item.id === selectedId);
    if (selectedItem) {
      props.onValueChange?.(selectedItem);
    }
  };

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      const selectedItem = props.items.find(
        (item) => item.id === props.selectedId,
      );
      props.onOpenChange?.(isOpen, selectedItem);
    }
  };

  return (
    <DropdownMenu onOpenChange={handleOpenChange}>
      <DropdownMenuTrigger disabled={props.items.length === 0} asChild>
        <InputDropdownTrigger
          label={props.label}
          className={cn(
            isActive &&
              "border-none bg-primary text-primary-foreground hover:bg-primary/90",
          )}
          disabled={props.items.length === 0}
        />
      </DropdownMenuTrigger>

      <DropdownMenuContent className="w-56">
        {props.title && (
          <>
            <DropdownMenuLabel>{props.title}</DropdownMenuLabel>
            <DropdownMenuSeparator />
          </>
        )}

        <DropdownMenuRadioGroup
          value={props.selectedId}
          onValueChange={handleValueChange}
        >
          {props.items.map((item) => (
            <DropdownMenuRadioItem
              key={item.id}
              value={item.id}
              disabled={item.enabled === undefined ? false : !item.enabled}
            >
              {item.value}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default RadioFilter;
